import { TBetslipEvent } from 'interfaces/betslip';

export const BETSLIP_EVENT_TEMPLATE = {
  competition_name: '',
  current_game_state: '',
  current_game_time: '',
  eventBase: undefined,
  eventId: 0,
  event_name: '',
  gameId: 0,
  game_info: { horse_xml: { HorceBXml: '' } },
  game_name: '',
  game_start_date: 0,
  isLive: false,
  marketType: '',
  market_name: '',
  region_name: '',
  sport_index: '',
  sport_name: '',
  team1: '',
  team2: '',
  coeficient: ''
} as TBetslipEvent;
